import React from 'react';

import { Publish as CommonPublish } from '../common';

export const Publish = () => {
  return <CommonPublish />;
};
